import { componentInfo } from "../blocks/custom-code/component-info.qwik.mjs";
import { CustomCode } from "../blocks/custom-code/custom-code.qwik.mjs";
import { componentInfo as componentInfo$1 } from "../blocks/embed/component-info.qwik.mjs";
import { Embed } from "../blocks/embed/embed.qwik.mjs";
import { componentInfo as componentInfo$2 } from "../blocks/form/form/component-info.qwik.mjs";
import { FormComponent } from "../blocks/form/form/form.qwik.mjs";
import { componentInfo as componentInfo$3 } from "../blocks/form/input/component-info.qwik.mjs";
import { FormInputComponent } from "../blocks/form/input/input.qwik.mjs";
import { componentInfo as componentInfo$5 } from "../blocks/form/select/component-info.qwik.mjs";
import { SelectComponent } from "../blocks/form/select/select.qwik.mjs";
import { componentInfo as componentInfo$4 } from "../blocks/form/submit-button/component-info.qwik.mjs";
import { SubmitButton } from "../blocks/form/submit-button/submit-button.qwik.mjs";
import { componentInfo as componentInfo$6 } from "../blocks/form/textarea/component-info.qwik.mjs";
import { Textarea } from "../blocks/form/textarea/textarea.qwik.mjs";
import { componentInfo as componentInfo$7 } from "../blocks/img/component-info.qwik.mjs";
import { ImgComponent } from "../blocks/img/img.qwik.mjs";
import { componentInfo as componentInfo$8 } from "../blocks/video/component-info.qwik.mjs";
import { Video } from "../blocks/video/video.qwik.mjs";
const getExtraComponents = () => [
  {
    component: CustomCode,
    ...componentInfo
  },
  {
    component: Embed,
    ...componentInfo$1
  },
  ...[
    {
      component: FormComponent,
      ...componentInfo$2
    },
    {
      component: FormInputComponent,
      ...componentInfo$3
    },
    {
      component: SubmitButton,
      ...componentInfo$4
    },
    {
      component: SelectComponent,
      ...componentInfo$5
    },
    {
      component: Textarea,
      ...componentInfo$6
    }
  ],
  {
    component: ImgComponent,
    ...componentInfo$7
  },
  {
    component: Video,
    ...componentInfo$8
  }
];
export {
  getExtraComponents
};
